module.exports = __webpack_public_path__ + "static/img/caseSoftwareBanner.959559e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/caseSoftwareBanner.png
// module id = WXA0
// module chunks = 2